export default "__VITE_ASSET__278bF4RI__"